<template>
  <div class="flex flex-col hidden">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div
          class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th
                  class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Email
                </th>
                <th
                  class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                >
                  Display Name
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(user, index) in allUsers" :key="index">
                <td
                  class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  {{ user.displayName }}
                </td>
                <td
                  class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500"
                >
                  {{ user.email }}
                </td>
              </tr>

              <!-- More rows... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.location.href = "/";
import { getAllUsers } from "../utils/functions";

export default {
  name: "AdminUsers",
  data() {
    return {
      allUsers: []
    };
  },
  computed: {
    // vectricStaff() {
    //   return this.allUsers.filter(s => s.email.endsWith("@vectric.com"));
    // }
  },
  mounted() {
    getAllUsers().then(res => {
      this.allUsers = res.data;
    });
  }
};
</script>

<style scoped></style>
